import React, { useState, useEffect, useRef } from "react";
import { Box, DataGrid, SelectBox } from "devextreme-react";
import { Item } from "devextreme-react/box";
import http from "../../utils/http";
import uri from "../../utils/uri";
import { store } from "../../services/store";
import { Button, Column, Editing, MasterDetail, Popup, Selection } from "devextreme-react/data-grid";

import {openThisDialog} from '../../store/dialog/dialogReducer' ;
import { useDispatch } from "react-redux";



const ItemTypes = props => {

    let dispatch = useDispatch();
    const gridRef = useRef();

    const onToolbarPreparing = e => {

        e.toolbarOptions.items.unshift({
            location: 'before',
            widget: 'dxButton',
            options: {
                text: 'Exportar a excel',
                icon: 'xlsxfile',
                type: 'success',
                stylingMode: "outlined",
                onClick: () => gridRef.current.instance.exportToExcel(false)
            }
        },{
            location: 'after',
            widget: 'dxButton',
            options: {
                stylingMode: "outlined",
                type: 'default',
                icon: 'add',
                text: 'Agregar tipo',
                onClick: e => dispatch(openThisDialog(0))
            }
        });
    }

    const refreshGrid=()=>{
        gridRef.current.instance.refresh();
    }

    return (
        <div className="container medium">

            <Box direction="row" width="100%" height={75}>

                <Item ratio={1}>
                   
                    <DataGrid
                        dataSource={store({ uri: { get: uri.itemTypes.get, insert: uri.itemTypes.insert } })}
                        showBorders={true}
                        showRowLines={true}
                        width="100%"
                        onSelectionChanged={selectionChanged}
                        onContentReady={contentReady}
                        onToolbarPreparing={onToolbarPreparing}
                        remoteOperations={{
                            paging: true,
                            filtering: true
                        }}
                        ref={gridRef}
                    >
                           <Editing
                            allowUpdating={true}
                            allowDeleting={false}
                            allowAdding={false}
                            useIcons={true}
                        >

                        </Editing>
                        
                        <Selection mode="single" />
                        <Column dataField="id" caption="Id" width={60} visible={true} allowEditing={false} />
                        <Column dataField="name" caption="Nombre" width={200} />
                        <Column type="buttons">
                            <Button name="edit" onClick={(e) => {  dispatch(openThisDialog(e.row.data.id)); }} />
                        </Column>
                        <MasterDetail
                            enabled={false}
                            component={renderDetail}
                        />

                    </DataGrid>
                </Item>

            </Box>

        </div>
    );
}

function contentReady(e) {
    if (!e.component.getSelectedRowKeys().length) { e.component.selectRowsByIndexes(0); }
}

function selectionChanged(e) {
    e.component.collapseAll(-1);
    e.component.expandRow(e.currentSelectedRowKeys[0]);
}

function renderDetail(props) {

    const { itemTypeProperties } = props.data.key;
    let attr='Sin datos.';
    if(itemTypeProperties.length>0){
       let names=[];
       itemTypeProperties.forEach(e => {
           names.push(e.property.name);
       });
       attr=names.join();
    }

    return (
        <div>
            <p><strong>Atributos:</strong>  {attr}</p>
        </div>
    );
}



export default ItemTypes;